import voterRegistrationService from '@/services/voterRegistration.service';

const state = {
  electionList: null,
  status: null,
  id: null,
  name: null,
  email: null,
  cpf: null,
  rg: null,
  treNumber: null,
  treZone: null,
  treSection: null,
  birth: null,
  motherName: null,
  electionName: null,
  messageError: ''
};

const mutations = {
  getList: (state, payload) => {
    state.status = payload.status;
    if (state.status !== 'ok') {
      state.messageError = payload.data;
    } else {
      state.electionList = payload.data;
    }
  },
  emailRegister: (state, payload) => {
    state.status = '';
    if (payload.data.id) {
      state.id = payload.data.id;
    }
    if (payload.status) {
      state.status = payload.status;
      if (state.status !== 'ok') {
        state.messageError = payload.data;
      }
    }
  },
  emailResend: (state, payload) => {
    state.status = '';
    if (payload.data.id) {
      state.id = payload.data.id;
    }
    if (payload.status) {
      state.status = payload.status;
      if (state.status !== 'ok') {
        state.messageError = payload.data;
      }
    }
  },
  emailValidate: (state, payload) => {
    state.status = payload.status;
    if (state.status !== 'ok') {
      state.messageError = payload.data;
    } else {
      const obj = payload.data;
      state.id = obj.id;
      state.name = obj.name;
      state.email = obj.email;
      state.cpf = obj.cpf;
      state.rg = obj.rg;
      state.treNumber = obj.tre_number;
      state.treZone = obj.tre_zone;
      state.treSection = obj.tre_section;
      state.birth = obj.birth;
      state.motherName = obj.mother_name;
      state.electionName = obj.electionName;
    }
  },
  completeRegistration: (state, payload) => {
    state.status = '';
    if (payload.status) {
      state.status = payload.status;
      if (state.status !== 'ok') {
        state.messageError = payload.data;
      }
    }
  }
};

const getters = {

};

const actions = {
  getList: async ({ commit }) => {
    const funcMutation = 'getList';
    const result = await voterRegistrationService.getElectionList();
    commit(funcMutation, result);
  },
  emailRegister: async ({ commit }, data) => {
    const funcMutation = 'emailRegister';
    return new Promise((resolve, reject) => {
      voterRegistrationService
        .emailRegister(data)
        .then(response => {
          commit(funcMutation, response);
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  emailResend: async ({ commit }, data) => {
    const funcMutation = 'emailResend';
    return new Promise((resolve, reject) => {
      voterRegistrationService
        .emailResend(data)
        .then(response => {
          commit(funcMutation, response);
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  emailValidate: async ({ commit }, data) => {
    const funcMutation = 'emailValidate';
    return new Promise((resolve, reject) => {
      voterRegistrationService
        .emailValidate(data)
        .then(response => {
          commit(funcMutation, response);
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  completeRegistration: async ({ commit }, data) => {
    const funcMutation = 'completeRegistration';
    return new Promise((resolve, reject) => {
      voterRegistrationService
        .completeRegistration(data)
        .then(response => {
          commit(funcMutation, response);
          resolve(response);
        })
        .catch(error => reject(error));
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
